"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFormatterBuilder = void 0;
const event_formatter_1 = require("./event-formatter");
class EventFormatterBuilder {
    constructor(params) {
        this._params = params;
    }
    createFormatter(subComponentName, params = {}, customData = {}) {
        return new event_formatter_1.EventFormatter({ builderParams: this._params, predefinedParams: params, predefinedCustomData: customData, subComponentName });
    }
}
exports.EventFormatterBuilder = EventFormatterBuilder;
//# sourceMappingURL=event-formatter-builder.js.map